import { css } from 'styled-components';

import { media } from './mediaQueries';

/**
 * Telefon: karty (np. statystyki) w poziomym swiperze zamiast kolumny jedna pod drugą.
 * Na ekranie mieści się 1,2 karty, więc widać, że można przesunąć. Przewija się sam rząd
 * (z przyciąganiem do karty), nie strona. Sięga do krawędzi ekranu (wcięcie treści 15 px).
 */
export const mobileSwiperCss = css`
  ${media.mobile} {
    display: flex !important;
    gap: 12px;
    margin-left: -15px;
    margin-right: -15px;
    padding: 0 15px 4px;
    overflow-x: auto;
    overscroll-behavior-x: contain;
    scroll-snap-type: x mandatory;
    scroll-padding: 0 15px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    & > * {
      flex: 0 0 calc((100% - 12px) / 1.2);
      min-width: 0;
      scroll-snap-align: start;
    }
  }
`;
